<template><markdown-wrapper><h1 id="carousel">Carousel <a class="header-anchor" href="#carousel">&#128279;</a></h1>
<blockquote>
<p>A slideshow component for cycling through elements, like a carousel. <strong>Nested carousels are not supported</strong>.</p>
</blockquote>
<p><ins class="adsbygoogle"
     style="display:block; text-align:center;"
     data-ad-layout="in-article"
     data-ad-format="fluid"
     data-ad-client="ca-pub-4714899946256166"
     data-ad-slot="4603582855"></ins></p>
<h2 id="example">Example <a class="header-anchor" href="#example">&#128279;</a></h2>
<carousel-example ref="carousel-example"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">section</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">carousel</span> <span class="hljs-attr">:indicators</span>=<span class="hljs-string">&quot;indicators&quot;</span> <span class="hljs-attr">:controls</span>=<span class="hljs-string">&quot;controls&quot;</span> <span class="hljs-attr">:interval</span>=<span class="hljs-string">&quot;interval&quot;</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">&quot;carousel&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">slide</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">&quot;(slide, index) in slides&quot;</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">&quot;index&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">&quot;width: 100%;height: 400px;&quot;</span> <span class="hljs-attr">:style</span>=<span class="hljs-string">&quot;{background:index % 2 === 0? &#x27;#99a9bf&#x27; : &#x27;#d3dce6&#x27;}&quot;</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;carousel-caption&quot;</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>This is {{slide.title}}<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">slide</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">carousel</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">form</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;form-inline&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">btn</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;indicators=!indicators&quot;</span>&gt;</span>Toggle Indicators<span class="hljs-tag">&lt;/<span class="hljs-name">btn</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">btn</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;controls=!controls&quot;</span>&gt;</span>Toggle Controls<span class="hljs-tag">&lt;/<span class="hljs-name">btn</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">btn</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;pushSlide&quot;</span>&gt;</span>Push Slide<span class="hljs-tag">&lt;/<span class="hljs-name">btn</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;form-group&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;input-group&quot;</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;input-group-addon&quot;</span>&gt;</span>Interval<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">input</span> <span class="hljs-attr">type</span>=<span class="hljs-string">&quot;number&quot;</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;form-control&quot;</span> <span class="hljs-attr">step</span>=<span class="hljs-string">&quot;1&quot;</span> <span class="hljs-attr">min</span>=<span class="hljs-string">&quot;0&quot;</span> <span class="hljs-attr">v-model.number</span>=<span class="hljs-string">&quot;interval&quot;</span> <span class="hljs-attr">style</span>=<span class="hljs-string">&quot;width: 100px&quot;</span>&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;input-group-addon&quot;</span>&gt;</span>ms<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">form</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">section</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">interval</span>: <span class="hljs-number">5000</span>,
        <span class="hljs-attr">indicators</span>: <span class="hljs-literal">true</span>,
        <span class="hljs-attr">controls</span>: <span class="hljs-literal">true</span>,
        <span class="hljs-attr">slides</span>: [
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 1&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 2&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 3&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 4&#x27;</span>}
        ]
      }
    },
    <span class="hljs-attr">methods</span>: {
      <span class="hljs-title function_">pushSlide</span> () {
        <span class="hljs-variable language_">this</span>.<span class="hljs-property">slides</span>.<span class="hljs-title function_">push</span>({<span class="hljs-attr">title</span>: <span class="hljs-string">`Slide <span class="hljs-subst">${<span class="hljs-variable language_">this</span>.slides.length + <span class="hljs-number">1</span>}</span>`</span>})
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- carousel-example.vue --&gt;</span>
</code></pre>
<h2 id="override-indicators">Override indicators <a class="header-anchor" href="#override-indicators">&#128279;</a></h2>
<p>Use the <code v-pre>indicators</code> slot to override default Bootstrap indicators.</p>
<p>This is a scoped slot, use <code v-pre>slot-scope=&quot;props&quot;</code> in Vue 2.5+, otherwise <code v-pre>scope=&quot;props&quot;</code>.</p>
<carousel-override-indicators ref="carousel-override-indicators"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">carousel</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">slide</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">&quot;(slide, index) in slides&quot;</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">&quot;index&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">&quot;width: 100%;height: 400px;&quot;</span> <span class="hljs-attr">:style</span>=<span class="hljs-string">&quot;{background:index % 2 === 0 ? &#x27;#99a9bf&#x27; : &#x27;#d3dce6&#x27;}&quot;</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;carousel-caption&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>This is {{slide.title}}<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">slide</span>&gt;</span>
    <span class="hljs-comment">&lt;!-- Use this slot for custom indicators --&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">&quot;indicators&quot;</span> <span class="hljs-attr">slot-scope</span>=<span class="hljs-string">&quot;props&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">ol</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;carousel-indicators custom-carousel-indicators&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">li</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">&quot;(slide, index) in slides&quot;</span>
            <span class="hljs-attr">:class</span>=<span class="hljs-string">&quot;{active:index === props.activeIndex}&quot;</span>
            @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;props.select(index)&quot;</span>&gt;</span>
            <span class="hljs-comment">&lt;!-- Anything you like here --&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">ol</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">carousel</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">slides</span>: [
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 1&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 2&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 3&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 4&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span>&gt;</span><span class="language-css">
  <span class="hljs-selector-class">.custom-carousel-indicators</span> <span class="hljs-selector-tag">li</span>, <span class="hljs-selector-class">.custom-carousel-indicators</span> <span class="hljs-selector-tag">li</span><span class="hljs-selector-class">.active</span> {
    <span class="hljs-attribute">width</span>: <span class="hljs-number">50px</span>;
    <span class="hljs-attribute">height</span>: <span class="hljs-number">8px</span>;
    <span class="hljs-attribute">margin</span>: <span class="hljs-number">0</span> <span class="hljs-number">3px</span>;
    <span class="hljs-attribute">border-radius</span>: <span class="hljs-number">0</span>;
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
<span class="hljs-comment">&lt;!-- carousel-override-indicators.vue --&gt;</span>
</code></pre>
<h2 id="custom-icons">Custom icons <a class="header-anchor" href="#custom-icons">&#128279;</a></h2>
<p><strong>Note</strong>: Bootstrap 3 has only 2 sets of icon supported for carousel at present:</p>
<ul>
<li><code v-pre>glyphicon glyphicon-chevron-left</code> and <code v-pre>glyphicon glyphicon-chevron-right</code> (default)</li>
<li><code v-pre>icon-prev</code> and <code v-pre>icon-next</code></li>
</ul>
<p>Additional CSS may needed if you prefer other icons or font...</p>
<p>Here is an example using <code v-pre>glyphicon-arrow-left</code> and <code v-pre>glyphicon-arrow-right</code>.</p>
<carousel-icons ref="carousel-icons"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">carousel</span> <span class="hljs-attr">icon-control-left</span>=<span class="hljs-string">&quot;my-icon glyphicon glyphicon-arrow-left&quot;</span> <span class="hljs-attr">icon-control-right</span>=<span class="hljs-string">&quot;my-icon glyphicon glyphicon-arrow-right&quot;</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">slide</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">&quot;(slide, index) in slides&quot;</span> <span class="hljs-attr">:key</span>=<span class="hljs-string">&quot;index&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">&quot;width: 100%;height: 400px;&quot;</span> <span class="hljs-attr">:style</span>=<span class="hljs-string">&quot;{background:index % 2 === 0 ? &#x27;#99a9bf&#x27; : &#x27;#d3dce6&#x27;}&quot;</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;carousel-caption&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>This is {{slide.title}}<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">slide</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">carousel</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">slides</span>: [
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 1&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 2&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 3&#x27;</span>},
          {<span class="hljs-attr">title</span>: <span class="hljs-string">&#x27;Slide 4&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">style</span>&gt;</span><span class="language-css">
<span class="hljs-comment">/* Using custom icons may require some additional CSS declarations */</span>
<span class="hljs-selector-class">.carousel-control</span> <span class="hljs-selector-class">.my-icon</span> {
  <span class="hljs-attribute">position</span>: absolute;
  <span class="hljs-attribute">top</span>: <span class="hljs-number">50%</span>;
  <span class="hljs-attribute">margin-top</span>: -<span class="hljs-number">10px</span>;
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
<span class="hljs-comment">&lt;!-- carousel-icons.vue --&gt;</span>
</code></pre>
<h1 id="api-reference">API Reference <a class="header-anchor" href="#api-reference">&#128279;</a></h1>
<h2 id="carousel-1"><a href="https://github.com/wxsms/uiv/blob/0.x/src/components/carousel/Carousel.vue">Carousel</a> <a class="header-anchor" href="#carousel-1">&#128279;</a></h2>
<h3 id="props">Props <a class="header-anchor" href="#props">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Type</th>
<th>Default</th>
<th>Required</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>v-model</code></td>
<td>Number</td>
<td></td>
<td></td>
<td>The current slide index, use this to manual change slide index.</td>
</tr>
<tr>
<td><code v-pre>indicators</code></td>
<td>Boolean</td>
<td>true</td>
<td></td>
<td>Show / hide the indicators.</td>
</tr>
<tr>
<td><code v-pre>controls</code></td>
<td>Boolean</td>
<td>true</td>
<td></td>
<td>Show / hide the controls.</td>
</tr>
<tr>
<td><code v-pre>interval</code></td>
<td>Number</td>
<td>5000</td>
<td></td>
<td>Slides running interval time in ms. Use <code v-pre>0</code> to stop interval.</td>
</tr>
<tr>
<td><code v-pre>icon-control-left</code></td>
<td>String</td>
<td>glyphicon glyphicon-chevron-left</td>
<td></td>
<td>The left control icon font class.</td>
</tr>
<tr>
<td><code v-pre>icon-control-right</code></td>
<td>String</td>
<td>glyphicon glyphicon-chevron-right</td>
<td></td>
<td>The right control icon font class.</td>
</tr>
</tbody>
</table></div><h3 id="slots">Slots <a class="header-anchor" href="#slots">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>default</code></td>
<td>The carousel body.</td>
</tr>
<tr>
<td><code v-pre>indicators</code></td>
<td>Override indicators. This is a scoped slot with <code v-pre>activeIndex</code> prop and <code v-pre>select</code> method. See example section above for usage details.</td>
</tr>
</tbody>
</table></div><h3 id="events">Events <a class="header-anchor" href="#events">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Params</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>change</code></td>
<td>index</td>
<td>Fire after slide changed, with the index number changed to.</td>
</tr>
</tbody>
</table></div></markdown-wrapper></template><style>
  .custom-carousel-indicators li, .custom-carousel-indicators li.active {
    width: 50px;
    height: 8px;
    margin: 0 3px;
    border-radius: 0;
  }
</style><style>
/* Using custom icons may require some additional CSS declarations */
.carousel-control .my-icon {
  position: absolute;
  top: 50%;
  margin-top: -10px;
}
</style><script>
  

  

  
export default {components:{'carousel-example':{"template":"<div class=\"markdown-live-example\">\n  <section>\n    <carousel :indicators=\"indicators\" :controls=\"controls\" :interval=\"interval\" ref=\"carousel\">\n      <slide v-for=\"(slide, index) in slides\" :key=\"index\">\n        <div style=\"width: 100%;height: 400px;\" :style=\"{background:index % 2 === 0? '#99a9bf' : '#d3dce6'}\"></div>\n        <div class=\"carousel-caption\">\n          <h3>This is {{slide.title}}</h3>\n        </div>\n      </slide>\n    </carousel>\n    <br/>\n    <form class=\"form-inline\">\n      <btn @click=\"indicators=!indicators\">Toggle Indicators</btn>\n      <btn @click=\"controls=!controls\">Toggle Controls</btn>\n      <btn @click=\"pushSlide\">Push Slide</btn>\n      <div class=\"form-group\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\">Interval</span>\n          <input type=\"number\" class=\"form-control\" step=\"1\" min=\"0\" v-model.number=\"interval\" style=\"width: 100px\">\n          <span class=\"input-group-addon\">ms</span>\n        </div>\n      </div>\n    </form>\n  </section>\n</div>",
    data () {
      return {
        interval: 5000,
        indicators: true,
        controls: true,
        slides: [
          {title: 'Slide 1'},
          {title: 'Slide 2'},
          {title: 'Slide 3'},
          {title: 'Slide 4'}
        ]
      }
    },
    methods: {
      pushSlide () {
        this.slides.push({title: `Slide ${this.slides.length + 1}`})
      }
    }
  },'carousel-override-indicators':{"template":"<div class=\"markdown-live-example\">\n  <carousel>\n    <slide v-for=\"(slide, index) in slides\" :key=\"index\">\n      <div style=\"width: 100%;height: 400px;\" :style=\"{background:index % 2 === 0 ? '#99a9bf' : '#d3dce6'}\"></div>\n      <div class=\"carousel-caption\">\n        <h3>This is {{slide.title}}</h3>\n      </div>\n    </slide>\n    <!-- Use this slot for custom indicators -->\n    <template slot=\"indicators\" slot-scope=\"props\">\n      <ol class=\"carousel-indicators custom-carousel-indicators\">\n        <li v-for=\"(slide, index) in slides\"\n            :class=\"{active:index === props.activeIndex}\"\n            @click=\"props.select(index)\">\n            <!-- Anything you like here -->\n        </li>\n      </ol>\n    </template>\n  </carousel>\n</div>",
    data () {
      return {
        slides: [
          {title: 'Slide 1'},
          {title: 'Slide 2'},
          {title: 'Slide 3'},
          {title: 'Slide 4'}
        ]
      }
    }
  },'carousel-icons':{"template":"<div class=\"markdown-live-example\">\n  <carousel icon-control-left=\"my-icon glyphicon glyphicon-arrow-left\" icon-control-right=\"my-icon glyphicon glyphicon-arrow-right\">\n    <slide v-for=\"(slide, index) in slides\" :key=\"index\">\n      <div style=\"width: 100%;height: 400px;\" :style=\"{background:index % 2 === 0 ? '#99a9bf' : '#d3dce6'}\"></div>\n      <div class=\"carousel-caption\">\n        <h3>This is {{slide.title}}</h3>\n      </div>\n    </slide>\n  </carousel>\n</div>",
    data () {
      return {
        slides: [
          {title: 'Slide 1'},
          {title: 'Slide 2'},
          {title: 'Slide 3'},
          {title: 'Slide 4'}
        ]
      }
    }
  }}}</script>